// src/app/services/canny.service.ts
import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";

declare global {
  interface Window {
    Canny?: ((...args: any[]) => void) & { q?: any[] };
  }
}

@Injectable({ providedIn: 'root' })
export class CannyService {
  private loaded = false;

  load(): any {
    // if (this.loaded) return Promise.resolve();
    //
    // return new Promise<void>((resolve, reject) => {
    //   if (!window.Canny) {
    //     const s = document.createElement('script');
    //     s.async = true;
    //     s.src = 'https://canny.io/sdk.js';
    //     s.onload = () => {
    //       this.loaded = true;
    //       resolve();
    //     };
    //     s.onerror = () => reject(new Error('Failed to load Canny SDK'));
    //     document.head.appendChild(s);
    //     // lightweight queue in case calls happen before load
    //     const c: any = (...args: any[]) => { c.q = c.q || []; c.q.push(args); };
    //     window.Canny = c;
    //   } else {
    //     this.loaded = true;
    //     resolve();
    //   }
    // });
  }

  async identify(user: {
    id: string | number
    email: string
    name: string
    avatarURL?: string
    created?: string | Date
  }) {
    // await this.load();
    // window.Canny!(
    //   'identify',
    //   {
    //     appID: environment.cannyAppId,
    //     user: {
    //       id: user.id,
    //       email: user.email,
    //       name: user.name,
    //       avatarURL: user.avatarURL,
    //       created: user.created
    //         ? new Date(user.created).toISOString()
    //         : undefined,
    //     },
    //   }
    // );
  }

  async open(path?: string) {
    await this.load();
    // Examples
    // this.open('feedback')
    // this.open('roadmap')
    // this.open('changelog')
    window.Canny!('open', path ?? 'feedback');
  }

  async close() {
    await this.load();
    window.Canny!('close');
  }
}
